<label class="form-labels mt-4">Productor</label>
<select (change)="updateProducer($event)" class="form-select" [(ngModel)]="idProducer">
    <option selected></option>
    <option [value]="producer.id" *ngFor="let producer of producers">{{ producer.fullname }}
    </option>
</select>